import { Controller } from "stimulus"

// Handles direct upload progress for project file uploads.
// Shows a progress bar during S3 upload, validates file size client-side.
export default class extends Controller {
  static targets = ["input", "submit", "progress", "bar", "status", "percent"]

  connect() {
    this.maxSize = 100 * 1024 * 1024 // 100 MB

    // Listen for ActiveStorage direct upload events
    this.element.addEventListener("direct-upload:initialize", this.onStart.bind(this))
    this.element.addEventListener("direct-upload:progress", this.onProgress.bind(this))
    this.element.addEventListener("direct-upload:end", this.onEnd.bind(this))
    this.element.addEventListener("direct-upload:error", this.onError.bind(this))
  }

  validate() {
    if (!this.hasInputTarget) return

    const file = this.inputTarget.files[0]
    if (!file) return

    if (file.size > this.maxSize) {
      alert(`File is too large (${(file.size / 1024 / 1024).toFixed(1)} MB). Maximum size is 100 MB.`)
      this.inputTarget.value = ""
      return
    }
  }

  onStart(event) {
    if (this.hasProgressTarget) {
      this.progressTarget.classList.remove("d-none")
    }
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = true
      this.submitTarget.value = "Uploading..."
    }
    if (this.hasStatusTarget) {
      this.statusTarget.textContent = "Uploading to server..."
    }
  }

  onProgress(event) {
    const { progress } = event.detail
    const pct = Math.round(progress)

    if (this.hasBarTarget) {
      this.barTarget.style.width = `${pct}%`
    }
    if (this.hasPercentTarget) {
      this.percentTarget.textContent = `${pct}%`
    }
  }

  onEnd(event) {
    if (this.hasBarTarget) {
      this.barTarget.style.width = "100%"
    }
    if (this.hasPercentTarget) {
      this.percentTarget.textContent = "100%"
    }
    if (this.hasStatusTarget) {
      this.statusTarget.textContent = "Processing..."
    }
  }

  onError(event) {
    event.preventDefault()
    if (this.hasStatusTarget) {
      this.statusTarget.textContent = "Upload failed. Please try again."
      this.statusTarget.classList.add("text-danger")
    }
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = false
      this.submitTarget.value = "Upload"
    }
  }
}
